<template>
    <div class="dashboard container">
        <!-- if POST, survey -->
        <transition name="fade">
            <div class="survey_section" v-if="loaded && showSurvey">
                <h1>{{appTextLanguage.dashboard.title[language]}}</h1>
                <div class="row">
                    <div class="col-xs-12">
                        <p class="register-statement" v-if="status == 'pre'">
                            {{appTextLanguage.dashboard.introText[language]}}
                        <p class="register-statement" v-else-if="status == 'live'">{{appTextLanguage.dashboard.introTextLive[language]}}</p>
                    </div>
                    <div class="btn-holder">
                        <div class="btn-wrap btn-wrap-start">
                            <a href="https://www.smartsurvey.co.uk/s/MyMoneyWeek/" target="_blank" class="btn btn-primary">{{appTextLanguage.dashboard.surveyButton[language]}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <modal name="survey-form" id="surveyModal" @before-close="doNotClose"
            reset=false
            transition="fade"
            overlayTransition="fade"
            height="auto"
            scrollable=true
            width="600px"
            pivotY=0.7>
                <div class="modal-close" @click="closeSurvey">
                    <span></span>
                </div>
                <div id="surveyWrapper" v-bar>
                    <form @submit.prevent="submitSurvey(form)" key="7" id="surveyForm" autocomplete="new-password">
                        <div class="row inputs">
                            <h3 class="formCategory" v-if="status == 'pre'">My Money Week {{currentyear}} General  Survey</h3>
                             <h3 class="formCategory" v-else-if="status == 'live'">My Money Week {{currentyear}} Live  Survey</h3>
                            <div class="col-12">
                                <span class="help" v-if="status == 'pre'">Thank you for taking the time to give us some feedback. Your feedback helps us to ensure we continue to provide engaging and relevant resources to help bring money management to life for young people.</span>
                                <span class="help" v-else-if="status == 'live'">We're excited to see so many schools and young people taking part in My Money Week this year! Thank you for taking the time to give us some feedback. We love hearing about all the fun and creative ways you have been bringing money management to life for young people. Your feedback helps us to understand the impact of My Money Week and ensure we continue to provide engaging and relevant resources.</span>
                            </div>
                            <div class="col-12">
                                <span class="help is-danger generic">{{surveyError}}</span>
                            </div>
                            <div class="col-xs-2" v-for="(question, index) in formQuestions">
                                <template v-if="question.type == 'checkbox'">
                                    <label class="form-check-label" :for="question.key">
                                        <input class="form-check-input" type="checkbox" v-validate.disable="(question.required != null && question.required == 1 ? 'required' : '')" :name="question.key" :id="question.key" v-model="form[question.key]">
                                        {{question.label}}
                                    </label>
                                    <span class="help is-danger checkbox">{{ errors.first(question.key) }}</span>
                                </template>

                                <template v-if="question.type == 'listradio'">
                                    <label class="form-label">{{question.label}}</label>
                                    <div class="radio_form">

                                        <label class="form-check-label" v-for="option in question.options">
                                            <input class="form-check-input" type="radio" v-validate.disable="(question.required != null && question.required == 1 ? 'required' : '')" :name="question.key" :value="option.Value" :checked="(option.Selected == 1 ? 'checked' : '')" v-model="form[question.key]">
                                            {{option.Label}}
                                        </label>
                                    </div>
                                    <span class="help is-danger checkbox">{{ errors.first(question.key) }}</span>
                                </template>

                                <template v-if="question.type == 'listcheckbox'">
                                    <label class="form-label">{{question.label}}</label>
                                    <div class="radio_form">
                                        <label class="form-check-label" v-for="(option, index) in question.options">
                                            <input class="form-check-input" type="checkbox" v-validate.disable="(question.required != null && question.required == 1 ? 'required' : '')" :name="question.key +'[]'" :value="option.Value" :checked="(option.Selected == 1 ? 'checked' : '')" v-model="form[question.key][option.Value]">
                                            {{option.Label}}
                                        </label>
                                    </div>
                                    <span class="help is-danger checkbox">{{ errors.first(question.key +'[]') }}</span>
                                </template>

                                <template v-if="question.type =='number'">
                                    <label :for="question.key" class="form-label">{{question.label}}</label>
                                    <input v-validate.disable="(question.required != null && question.required == 1 ? 'required|numeric' : '')" class="form-input"
                                        :class="{'input': true, 'is-danger': errors.has(question.key) }" 
                                        type="number" :min="question.num_min" :max="question_num_max" :name="question.key" :id="question.key" v-model="form[question.key]"/>
                                    <span class="help is-danger">{{ errors.first(question.key) }}</span>
                                </template>

                                <template v-if="question.type =='textarea'">
                                    <label :for="question.key" class="form-label">{{question.label}}</label>
                                    <textarea v-validate.disable="(question.required != null && question.required == 1 ? 'required' : '')" class="form-input textarea"
                                    :class="{'input': true, 'is-danger': errors.has(question.key) }" :name="question.key" :id="question.key" v-model="form[question.key]">
                                    </textarea>
                                    <span class="help is-danger">{{ errors.first(question.key) }}</span>
                                </template>

                                <template v-if="question.type =='textbox'">
                                    <label :for="question.key" class="form-label">{{question.label}}</label>
                                    <input v-validate.disable="(question.required != null && question.required == 1 ? 'required' : '')" class="form-input"
                                        :class="{'input': true, 'is-danger': errors.has(question.key) }"
                                        type="text" :name="question.key" :id="question.key" autocomplete="new-password" v-model="form[question.key]"/>
                                    <span class="help is-danger">{{ errors.first(question.key) }}</span>
                                </template>
                            </div>
                            <div class="col-xs-2">
                                <!-- Anonymise data checkbox -->
                                <label class="form-check-label" for="anonymise_data">
                                    <input class="form-check-input" type="checkbox" name="anonymise_data" id="anonymise_data" v-model="form['anonymise_data']">
                                    Please keep my feedback anonymous
                                </label>
                                <span class="help is-danger checkbox">{{ errors.first("anonymise_data") }}</span>
                            </div>
                        </div>
                        <div class="row submit">
                            <div class="col-xs-12 btn-holder">
                                <div class="btn-wrap btn-wrap-start">
                                    <input type="submit" value="Submit Survey" class="btn btn-primary"/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
        </modal>

        <transition name="fade">
            <div class="dashboard_section" v-if="status == 'live' && loaded">
                 <h1>{{appTextLanguage.dashboard.liveTitle[language]}}</h1>
                 <span v-if="language == 'en'">
                    <strong>#MyMoneyWeek 9th - 13th June 2025</strong>
                </span>
                <span v-if="language == 'cy'">
                    <strong>#WythnosFyArian 9eg - 13eg Mehefin 2025</strong> 
                </span>
                <div class="row">
                    <div class="col-xs-12" v-html="appTextLanguage.dashboard.liveIntro[language]">
                    </div>
                </div>
                <div class="row dashboard_main">
                    <div class="dashboard_block dashboard_primary " v-bind:class="{ 'active_section': type == 'primary' }">
                        <h2>{{appTextLanguage.dashboard.liveSwitchTitleP[language]}}</h2>
                        <div class="dashboard_middle_wrap">
                            <div class="dashboard_image">
                                <img src="@/assets/placeholder/primary_placeholder.png" alt="Primary alt tag">
                            </div>
                            <div class="dashboard_information">
                                <div class="dashboard_get_started">
                                    <input type="submit" v-model="appTextLanguage.dashboard.getStartedButton[language]" class="btn btn-primary" @click="getStarted('primary')" />
                                </div>
                                <div class="dashboard_resources" v-if="liveResources != null">
                                    <h4>{{appTextLanguage.dashboard.resources[language]}}</h4>
                                    <ul>
                                        <li v-for="(presource, index) in liveResources.primary" v-if="index != 0">
                                            <a target="_blank" v-bind:href="presource.url" @click="logResourceDownload('primary', currentyear, presource.filename, index)" @click.middle="logResourceDownload('primary', currentyear, presource.filename, index)">
                                                {{presource.filename}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="resource_button">
                                    <input type="submit" v-model="appTextLanguage.dashboard.viewResouresButton[language]" class="btn btn-primary" @click="changeType()"/>
                                </div>
                                <div class="dashboard_video" v-if="liveVideos != null && Object.keys(liveVideos['primary']['questions']).length > 0 && language == 'en'">
                                    <template v-if="hasStarted(currentyear, 'primary') != 0">
                                        <router-link class="btn btn-primary started continue" :to="{name:'Video', params:{year:currentyear, type: 'primary', videoId: hasStarted(currentyear, 'primary')}}" v-if="!completed(currentyear, 'primary')">Continue <span v-if="type == 'primary'">Journey</span></router-link>
                                        <router-link class="btn btn-primary started continue see_journey" :to="{name:'VideoMap', params:{year:currentyear, type: 'primary'}}" v-if="completed(currentyear, 'primary')"><span v-if="type == 'primary'">See</span> Journey</router-link>
                                        <router-link class="btn btn-primary started" :to="{name:'Video', params:{year:currentyear, type: 'primary', videoId: 1}}" v-on:click.native="restartVideo(currentyear, 'primary')">Start Over</router-link>
                                    </template>
                                    <template v-else>
                                        <router-link class="btn btn-primary video_journey_btn" :to="{name:'Video', params:{year:currentyear, type: 'primary', videoId: 1}}">Video Journey</router-link>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dashboard_expand" @click="changeType()" v-bind:class="type">
                        <div>{{appTextLanguage.dashboard.expandToViewMore[language]}}</div>
                    </div>
                    <div class="dashboard_block dashboard_secondary" v-bind:class="{ 'active_section': type == 'secondary'}">
                        <h2>{{appTextLanguage.dashboard.liveSwitchTitleS[language]}}</h2>
                        <div class="dashboard_middle_wrap">
                            <div class="dashboard_image">
                                <img src="@/assets/placeholder/secondary_placeholder.png" alt="Secondary alt tag">
                            </div>
                            <div class="dashboard_information">
                                <div class="dashboard_get_started">
                                    <input type="submit" v-model="appTextLanguage.dashboard.getStartedButton[language]"  class="btn btn-primary" @click="getStarted('secondary')" />
                                </div>
                                <div class="dashboard_resources" v-if="liveResources != null">
                                    <h4>{{appTextLanguage.dashboard.resources[language]}}</h4>
                                    <ul>
                                        <li v-for="(presource, index) in liveResources.secondary" v-if="index != 0" @click="logResourceDownload('secondary', currentyear, presource.filename, index)" @click.middle="logResourceDownload('secondary', currentyear, presource.filename, index)">
                                            <a target="_blank" v-bind:href="presource.url">
                                                {{presource.filename}}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="resource_button">
                                    <input type="submit" v-model="appTextLanguage.dashboard.viewResouresButton[language]" class="btn btn-primary" @click="changeType()"/>
                                </div>
                                <div class="dashboard_video" v-if="liveVideos != null &&  Object.keys(liveVideos['secondary']['questions']).length > 0 && language == 'en'">
                                    <template v-if="hasStarted(currentyear, 'secondary') != 0">
                                        <router-link class="btn btn-primary started continue" :to="{name:'Video', params:{year:currentyear, type: 'secondary', videoId: hasStarted(currentyear, 'secondary')}}" v-if="!completed(currentyear, 'secondary')">Continue <span v-if="type == 'secondary'">Journey</span></router-link>
                                        <router-link class="btn btn-primary started continue see_journey" :to="{name:'VideoMap', params:{year:currentyear, type: 'secondary'}}" v-if="completed(currentyear, 'secondary')"><span v-if="type == 'secondary'">See</span> Journey</router-link>
                                        <router-link class="btn btn-primary started" :to="{name:'Video', params:{year:currentyear, type: 'secondary', videoId: 1}}" v-on:click.native="restartVideo(currentyear, 'secondary')">Start Over</router-link>
                                    </template>
                                    <template v-else>
                                        <router-link class="btn btn-primary video_journey_btn" :to="{name:'Video', params:{year:currentyear, type: 'secondary', videoId: 1}}">Video Journey</router-link>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="archive_section" v-if="loaded">
                <h1>{{appTextLanguage.dashboard.resourceArchiveTitle[language]}}</h1>
                <span v-if="language == 'en'">
                    <strong>#MyMoneyWeek 9th - 13th June 2025</strong>
                </span>
                <span v-if="language == 'cy'">
                    <strong>#WythnosFyArian 9eg - 13eg Mehefin 2025</strong> 
                </span>
                <div class="row">
                    <div class="col-xs-12">
                        <p>{{appTextLanguage.dashboard.resourceArchiveText[language]}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="archive_filters">
                        <div class="year_filter_wrap selectbox">
                            <label for="year_filter">{{appTextLanguage.dashboard.year[language]}}</label>
                            <select id="year_filter" class="form-input" v-model="filters.year" name="year">
                                <option></option>
                                <option v-for="fyears in filterYears" v-if="(status != 'live' && status != 'pre') || ((status == 'live' || status == 'pre') && (fyears != currentyear || fyears == currentyear && currentmonth >= '7' && status == 'pre'))">{{fyears}}</option>

                            </select>
                        </div>
                        <div class="age_fiter_wrap selectbox">
                            <label for="group">{{appTextLanguage.dashboard.resourceAgeGroup[language]}}</label>
                            <select id="group" class="form-input" v-model="filters.group" name="group">
                                <option></option>
                                <option value="primary">{{appTextLanguage.dashboard.age[language]}} 3-11</option>
                                <option value="secondary">{{appTextLanguage.dashboard.age[language]}} 11-19+</option>
                            </select>
                        </div>
                    </div>

                    <div class="archive_contents">
                        <transition-group name="year-anim" tag="div">
                            <div class="archive_year" v-for="(item, index) in allResources" v-bind:key="item[0]" v-if="((item[0] == filters.year) || filters.year == '') && (((status == 'live' || status =='pre') && (item[0] != currentyear || item[0] == currentyear && currentmonth >= '7' && status == 'pre'))  || status =='post')">
                                <h3 class="archive_year_title" v-if="item[1]['primary'].length > 0 || item[1]['secondary'].length > 0">{{item[0]}}</h3>
                                <transition-group name="type-anim" tag="div">
                                    <div class="primary_resources" v-if="('primary' == filters.group) || filters.group == ''" v-bind:key="item[0] + '_primary'">
                                        <h4 class="archive_type_title" v-if="item[1]['primary'].length > 0 || (Object.keys(allVideos[item[0]]['primary']['questions']).length > 0 && language == 'en')">{{appTextLanguage.dashboard.liveSwitchTitleP[language]}}</h4>
                                        <div class="resource_section_wrap">
                                            <div class="video_journey" v-if="Object.keys(allVideos[item[0]]['primary']['questions']).length > 0 && language == 'en'">
                                                <router-link :to="{name:'Video', params:{year:item[0], type: 'primary', videoId: hasStarted(item[0], 'primary')}}">
                                                    <span class="video-img-wrap">
                                                        <img class="video-thumbnail-image" :src="getThumbnailUrl(allVideos[item[0]]['primary']['questions'][1].youtubeId)">
                                                        <span class="watch-extra"><i class="icon-play-button"></i>Video Journey</span>
                                                    </span>
                                                </router-link>
                                            </div>
                                            <div class="resource_links">
                                                <a v-for="(itemt, indext) in item[1]['primary']" target="_blank" v-bind:href="itemt['url']" @click="logResourceDownload('primary', item[0], itemt['filename'], indext)" @click.middle="logResourceDownload('primary', item[0], itemt['filename'], indext)">{{itemt['filename']}}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="secondary_resources" v-if="('secondary' == filters.group) || filters.group == ''" v-bind:key="item[0] + '_secondary'">
                                        <h4 class="archive_type_title" v-if="item[1]['secondary'].length > 0 || (Object.keys(allVideos[item[0]]['secondary']['questions']).length > 0 && language == 'en')">{{appTextLanguage.dashboard.liveSwitchTitleS[language]}}</h4>
                                        <div class="resource_section_wrap">
                                            <div class="video_journey" v-if="Object.keys(allVideos[item[0]]['secondary']['questions']).length > 0 && language == 'en'">
                                                <router-link :to="{name:'Video', params:{year:item[0], type: 'secondary', videoId: hasStarted(item[0], 'secondary')}}">
                                                    <span class="video-img-wrap">
                                                        <img class="video-thumbnail-image" :src="getThumbnailUrl(allVideos[item[0]]['secondary']['questions'][1].youtubeId)">
                                                        <span class="watch-extra"><i class="icon-play-button"></i>Video Journey</span>
                                                    </span>
                                                </router-link>
                                            </div>
                                            <div class="resource_links">
                                                <a v-for="(itemt, indext) in item[1]['secondary']" target="_blank" v-bind:href="itemt['url']" @click="logResourceDownload('secondary', item[0], itemt['filename'], indext)" @click.middle="logResourceDownload('secondary', item[0], itemt['filename'], indext)">{{itemt['filename']}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </transition-group>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>

    export default {
        name: 'Dashboard',
        data: function () {
            return {
                language: null,
                appTextLanguage: null,
                type: this.$store.getters.getType,
                status: false,
                filters: {
                    year: '',
                    group: ''
                },
                filterYears: [],
                currentyear: new Date().getFullYear(),
                currentmonth: new Date().getMonth(),
                liveResources: null,
                liveVideos: null,
                loaded: false,
                surveyError: null,
                formQuestions: null,
                completedSurvey: false,
                form: {
                },
                showSurvey: true
            }
        },
        methods: {
            doNotClose(event) {
                if(typeof window.confirmClose === 'undefined' || window.confirmClose == false) {
                    event.stop();
                    this.$toasted.clear();
                    this.$toasted.show(this.appTextLanguage.dashboard.surveySuccess[this.language], {
                        position: 'top-center',
                        type: "info",
                        className: 'surveyCheck',
                        singleton: true,
                        action: [
                            {
                                text: this.appTextLanguage.popup.confirm[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                    window.confirmClose = true;
                                    this.$modal.hide('survey-form');
                                }
                            },
                            {
                                text: this.appTextLanguage.popup.cancel[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        ]
                    });
                } else {
                    window.confirmClose = false;
                    const dictionary = {
                        en: {
                            messages:{
                                required: field => this.appTextLanguage.account.the[this.language] +' ' + field.replace('forgotten_email', 'email').replace(/_/g, ' ').replace('login', '').replace('resetemail', 'email').replace('resetpassword', this.appTextLanguage.account.newpassword[this.language]) + ' ' + this.appTextLanguage.account.fieldRequiredRaw[this.language],
                                min: () => this.appTextLanguage.account.passwordRequirement[this.language],
                                email: () => this.appTextLanguage.account.emailFormat[this.language]
                            }
                        }
                    };

                    this.$validator.localize(dictionary);
                }
                

            },
            changeType() {
                if(this.type == 'primary') {
                    this.type = 'secondary';
                } else {
                    this.type = 'primary';
                }
            },
            toggleSurvey() {
                this.$modal.show('survey-form');
            },
            closeSurvey() {
                this.$modal.hide('survey-form');
            },
            getThumbnailUrl: function(youtubeId){
                let format = 'mqdefault';
                let url = 'https://img.youtube.com/vi/' + youtubeId + '/' + format +'.jpg';
                return url;
            },
            submitSurvey(form) {
                console.log(form);

                const dictionary = {
                    en: {
                        messages:{
                            numeric: () => this.appTextLanguage.account.fieldNumeric[this.language],
                            required: field => this.appTextLanguage.account.fieldRequired[this.language]
                        }
                    }
                };

                this.$validator.localize(dictionary);
                
                this.$validator.validateAll().then((result) => {

                    if (result) {
                        this.sendSurvey(form);
                    }
                });
            },
            grabSurvey(popup) {
                var token = this.$store.getters.getBearerToken;
                // Grab status before everything
                this.$http.get(process.env.WP_ENDPOINT + 'mmw/v1/mmw-survey', {timeout: 60000}).then(function (response) {
                    console.log('MMW Survey');
                    if (response.data.code == "200") {
                        this.surveyID = response.data.form_id;

                        if(this.status == 'pre') {
                            this.survey = this.$store.getters.getSurveyCompletedGeneral;
                        }
                        else { 
                           
                            this.survey = this.$store.getters.getSurveyCompletedLive; 

                            console.log(this.survey);
                        }
                     
                       
                        if(this.survey == this.surveyID){
                            // Completed survey, don't show
                            this.showSurvey = false;
                            
                        } else {
                            this.buildSurvey(response.data.data, popup);
                            
                        }
                    } else {
                        // Error
                    }

                    this.loaded = true;
                }, function (response) {
                    // Error
                    console.log(response);
                    this.loaded = true;
                });  
            },
            buildSurvey(data, popup) {
                console.log(data);
                this.formQuestions = data;

                Object.entries(data).forEach(([key, value]) => {
                    
                    if(value.type == 'listcheckbox'){
                        this.form[value.key] = {};
                        // Add the checkbox options
                        Object.entries(value.options).forEach(([keyc, valuec]) => {
                            this.form[value.key][valuec.Value] = null;
                        });
                    } else {
                        this.form[value.key] = null;
                    }
                   
                });
                // console.log(this.form);
                this.form['anonymise_data'] = false;
                if(popup) { 
                    setTimeout(() => {
                        this.$modal.show('survey-form');
                    }, 1000);
                }
            },
            sendSurvey(form) {
                form.surveyID = this.surveyID;
                form.language = this.language;
                
                    var auth = {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getBearerToken
                        },
                        timeout: 60000
                    };

                this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/mmw-submit-survey', form, auth).then(function (response) {
                    console.log(response.data);
                    if(response.data.code == 200) {
                        // Success
                        window.confirmClose = true;
                        this.$modal.hide('survey-form');
                        this.$toasted.show(this.appTextLanguage.dashboard.surveySuccessSubmit[this.language], {
                            duration: 6000,
                            position: 'top-center',
                            type: "success",
                            action: {
                                text: this.appTextLanguage.introform.close[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        });

                        const dictionary = {
                            en: {
                                messages:{
                                    required: field => this.appTextLanguage.account.the[this.language] + ' ' + field.replace('forgotten_email', 'email').replace(/_/g, ' ').replace('login', '').replace('resetemail', 'email').replace('resetpassword', this.appTextLanguage.account.newpassword[this.language]) +  ' ' + this.appTextLanguage.account.fieldRequiredRaw[this.language],
                                    min: () => this.appTextLanguage.account.passwordRequirement[this.language],
                                    email: () => this.appTextLanguage.account.emailFormat[this.language]
                                }
                            }
                        };

                        this.$validator.localize(dictionary);

                        // Store against profile 
                    if(this.status == 'pre') {
                        this.$store.commit('setSurveyCompletedGeneral', this.surveyID);
                    }
                    else {
                        this.$store.commit('setSurveyCompletedLive', this.surveyID);
                    }
                        this.showSurvey = false;
                    }
                },function (response) {
                    // Error
                    console.log(response.data)
                });
            },
            getStarted(type) {
                // Open file
                if(type == 'primary') {
                    var filename = this.liveResources.primary[0].filename;
                    window.open(this.liveResources.primary[0].url);
                } else {
                    var filename = this.liveResources.secondary[0].filename;
                    window.open(this.liveResources.secondary[0].url);
                }
                // Log file
                this.logResourceDownload(type, this.currentyear, filename, 0);
            },
            logResourceDownload(type, year, filename, index) {
                index = index +1;
                var logResource = {
                    type, year, filename, index
                };
                this.$store.dispatch('addResourceDownload', logResource);
            },
            hasStarted(year, type){
                var started = this.$store.getters.getlastVideoID(year, type);
                if(started == null) {
                    started = 0;
                }
                if((year != this.currentyear || this.status != 'live') && started == 0) {
                    return 1;
                }

                return started;
            },
            completed(year, type) {
                return this.$store.getters.getCompleted(year, type);
            },
            restartVideo(year, type) {
                // Restart video sequence, but not tracking data.
                var reset = {
                    year, type
                }
                this.$store.commit('restartVideoData', reset);
            }
        },
        created() {
            // const dictionary = {
            //     en: {
            //         messages:{
            //             numeric: () => 'This field can only contain numeric characters.',
            //             required: field => 'This field is required.'
            //         }
            //     }
            // };

            this.appTextLanguage = this.$store.getters.getAppTextLanguage;
            this.appText = this.$store.getters.getAppText;
            this.language = this.$store.getters.getLanguage;

            const showSurveyPopup = this.$route.query.survey;
 

            // this.$validator.localize(dictionary);

            var cyear = new Date().getFullYear();
            this.status = this.$store.getters.getStatus;
            var allYears = this.$store.getters.getYears.reverse();

            this.filterYears = allYears;

            this.resources = this.$store.getters.getAllResources;
            
            var myArray = Object.keys(this.resources).map(v => new Array(v, this.resources[v]));
            this.allResourcesEng = myArray.reverse();

            this.resourcesWelsh = this.$store.getters.getAllResourcesWelsh;
            var myArrayWelsh = Object.keys(this.resourcesWelsh).map(v => new Array(v, this.resourcesWelsh[v]));

            this.allResourcesCy = myArrayWelsh.reverse();

            if(this.language == 'en') {
                this.allResources = this.allResourcesEng;
            }
            else {
                this.allResources = this.allResourcesCy;
            }

            this.allVideos = this.$store.getters.getVideoData;

            // Current years resources
            if(this.status == 'live') { 
                this.liveVideos = this.allVideos[cyear];
              if(this.language == 'en') {
                this.liveResources =  this.resources[cyear];
              }
              else {
                 this.liveResources =  this.resourcesWelsh[cyear]; 
              }
            }

            if(this.status == 'pre') {
                this.survey = this.$store.getters.getSurveyCompletedGeneral;
                const surveyID = this.$store.getters.getSurveyGeneralID;

                if(surveyID == this.survey) {
                this.completedSurvey = true;
                this.showSurvey = false;
                }
            }
            else {
                this.survey = this.$store.getters.getSurveyCompletedLive;
                const surveyID = this.$store.getters.getSurveyLiveID;
              
              if(surveyID == this.survey) {
                this.completedSurvey = true;
                this.showSurvey = false;
                }
            }



            if((!this.completedSurvey) || showSurveyPopup) {
                // Grab Survey data
                this.grabSurvey(showSurveyPopup);
            } else {
                this.loaded = true;
            }
        },
        watch: {
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;
                var cyear = new Date().getFullYear();
                if(this.language == 'en') {
                    this.allResources = this.allResourcesEng;
                    this.liveResources =  this.resources[cyear];
                }
                else {
                    this.allResources = this.allResourcesCy; 
                    this.liveResources =  this.resourcesWelsh[cyear]; 
                }
            }
        },
        
    }


</script>

<!-- "scoped" attribute limits CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue